import React from 'react';
import { ReactComponent as TestKit } from 'assets/icons/testKits/testKit.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';

interface IRecommendedProductCardProps {
  title: string;
  amount: number;
  onDelete: () => void;
}

const RecommendedProductCard: React.FC<IRecommendedProductCardProps> = ({
  title,
  amount,
  onDelete,
}) => {
  return (
    <div className="desktop:px-5 desktop:py-3 px-3 py-1.5 border border-gray-opacity-15 rounded-10 gap-2 desktop:gap-2.5 bg-base-content flex flex-row items-center ">
      <TestKit className="w-5 min-w-[1.25rem] desktop:min-w-[1.5rem] desktop:w-6" />
      <div className="flex flex-col desktop:flex-row justify-start desktop:items-center desktop:gap-2.5">
        <span className="text-neutral-800 font-semibold text-base">
          {title}
        </span>
        <span className="text-med-gray-3 font-medium text-sm">{`Qty: ${amount} test`}</span>
      </div>
      <button className="p-0 bg-transparent ml-auto" onClick={onDelete}>
        <Close />
      </button>
    </div>
  );
};

export default RecommendedProductCard;
